module.exports = __webpack_public_path__ + "static/media/IHMPending.9c9eb93d.svg";